import React from 'react';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';

export default () => (
    <div css={containerStyle}>
        <div>
            <img
                src="https://assets.fevercdn.com/promotion/icon/Loading.gif"
                alt="loading"
                css={imgStyle}
            />
            <Typography variant="h6" css={css(`padding-top: 1rem;`)}>
                Loading...
            </Typography>
        </div>
    </div>
);

const containerStyle = css`
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    > div {
        text-align: center;
    }
`;

const imgStyle = css`
    width: 120px;
    height: 120px;
`;
